import React from 'react';
import { Link } from 'react-router-dom';

function PrivacyPage() {
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="text-gray-600 mb-4">Last updated: May 2026</p>
      <div className="prose prose-gray space-y-4 text-gray-700">
        <p>
          WhoDatNumber helps users look up phone numbers and share community reports. We use
          Firebase Authentication and Firestore to store account and report data.
        </p>
        <p>
          When you sign in with Google or email, we store your user ID and email. Reports you
          submit are published on number pages when approved; admins may unapprove or delete reports. Phone number pages may be indexed by search
          engines unless marked private by a verified owner.
        </p>
        <p>
          We use cookies and similar technologies for authentication and site functionality. Third-party
          advertising (Google AdSense) may use cookies when enabled — see Google&apos;s policies for details.
        </p>
        <p>
          Contact the site operator for data access or deletion requests regarding your account.
        </p>
      </div>
      <Link to="/" className="inline-block mt-8 text-blue-600 hover:underline">
        Back to home
      </Link>
    </div>
  );
}

export default PrivacyPage;

